import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { startLoginOrExplain } from '../../actions/login';

/**
 * The one login call-to-action of the anonymous restricted-brand homepage
 * (merger of the former LoginMsgForm and OnlySsoForm): the brand message when
 * the S3 config carries one (loginMsgKey), the generic corporate-login
 * invitation otherwise, and a button that starts the shared login flow.
 *
 * @typedef {object} LoginCtaProps
 * @property {string} [msgKey] - brand-specific message key (branded.loginMsgKey)
 */
class LoginCta extends Component {
  constructor(props) {
    super(props);
    this.startLogin = this.startLogin.bind(this);
  }

  startLogin() {
    this.props.startLoginOrExplain();
  }

  render() {
    return (
      <div className="login-cta">
        <div className="scope-title">
          <FormattedMessage id={this.props.msgKey || 'only.sso.homepage.title'} />
        </div>
        <button
          onClick={this.startLogin}
          className="btn btn-md btn-accent primary-btn"
        >
          <FormattedMessage id="label.login" />
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = { startLoginOrExplain };

export default connect(null, mapDispatchToProps)(LoginCta);
